import { createFileRoute } from "@tanstack/react-router"
import { AvatarLibraryPageWrapper } from "./-AvatarLibraryPage"

export const Route = createFileRoute("/tools/avatar-library")({
  component: AvatarLibraryPageWrapper,
})
